package com.ijoin.data.api

import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.isSuccess

/**
 * Wraps an API request with common error handling, including token refresh support.
 */
suspend fun safeApiCall(
    request: suspend () -> HttpResponse
): Result<HttpResponse> {
    return try {
        val response = ApiClient.executeWithTokenRefresh { request() }
        if (!response.status.isSuccess()) {
            val errorBody = runCatching { response.bodyAsText() }.getOrNull()
            val message = errorBody?.takeIf { it.isNotBlank() }
                ?: "Request failed with status ${response.status}"
            throw ApiException(response.status, message)
        }
        Result.success(response)
    } catch (e: Exception) {
        Result.failure(e)
    }
}
